import { Alert, Box, Snackbar } from '@mui/material';
import useSnackbarStore from 'src/store/snackbar';

export const AppSnackbar = () => {
  const { snackbar, closeSnackbar } = useSnackbarStore();
  const isTopPlacement = snackbar.options.placement === 'top';

  return (
    <Snackbar
      data-testid="app-snackbar"
      open={snackbar.open}
      autoHideDuration={snackbar.options.autoHide}
      onClose={(_event, reason) => {
        if (reason === 'clickaway' && snackbar.options.action) return;
        closeSnackbar();
      }}
      anchorOrigin={{ vertical: isTopPlacement ? 'top' : 'bottom', horizontal: 'center' }}
      sx={isTopPlacement ? { top: '8px' } : undefined}
    >
      {isTopPlacement ? (
        <Box
          sx={(theme) => ({
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem',
            padding: '0.4375rem 0.4375rem 0.4375rem 0.875rem',
            borderRadius: '0.625rem',
            backgroundColor: theme.palette.custom.OV.sys.surfaceContainerHighest,
            color: theme.palette.custom.OV.sys.onBackground,
            border: `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
            boxShadow: theme.shadows[8],
            fontSize: '0.78125rem',
          })}
        >
          <Box component="span">{snackbar.message}</Box>
          {snackbar.options.action}
        </Box>
      ) : (
        <Alert
          onClose={closeSnackbar}
          severity={snackbar.options.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      )}
    </Snackbar>
  );
};
